import React, { useMemo } from "react";
import { Check, X } from "lucide-react";

import { cn } from "lib/utils";
import type { FormatMessage } from "./changePasswordValidation";
import { getPasswordConstraints } from "./changePasswordValidation";

type PasswordConstraintsProps = {
    password: string;
    formatMessage: FormatMessage;
};

const PasswordConstraints: React.FC<PasswordConstraintsProps> = ({ password, formatMessage }) => {
    const constraints = useMemo(() => getPasswordConstraints(password), [password]);

    return (
        <ul className="grid gap-2 text-sm text-slate-600 sm:grid-cols-2">
            {constraints.map((constraint) => {
                const label = formatMessage(constraint.labelKey);
                const status = formatMessage(
                    constraint.valid
                        ? "profile.settings.security.password.constraint.status.valid"
                        : "profile.settings.security.password.constraint.status.invalid"
                );

                return (
                    <li
                        key={constraint.key}
                        className="flex items-start gap-2"
                        aria-label={`${label} ${status}`}
                    >
                        {constraint.valid ? (
                            <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden />
                        ) : (
                            <X className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden />
                        )}
                        <span className={cn(constraint.valid && "text-slate-900")}>{label}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default PasswordConstraints;
